import { TileButtonTwo } from '@sketch-note/design-system/src/components/tile-button';
import { Button } from '@sketchnote/shared-components';
import React, { useEffect, useState } from 'react';
import Analytics from 'src/api/services/analytics/analytics';

import { useProfileStore } from '../../store';

export const DisplayOption = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const { careerPaths, setCareerPaths } = useProfileStore((state) => state);
  const [interest, setInterest] = useState<any>({});
  const [selection, setSelection] = useState<any>([]);
  const [selectionIndex, setSelectionIndex] = useState<any>([]);

  useEffect(() => {
    if (careerPaths.interest) {
      setInterest({ ...careerPaths.interest });
    }
    if (careerPaths.interest?.answer) {
      setSelection([...careerPaths.interest.answer]);
      setSelectionIndex([...careerPaths.interest.answerIndex]);
    }
  }, [careerPaths]);

  const handleMultiselectDropdown = (value) => {
    const temp2 = { ...interest };
    const selectionTemp = [...selection];
    const ind = selectionTemp.findIndex((item) => item.value === value.value);
    const selectionT = temp2.options.findIndex((item) => item.value === value.value);

    if (ind == -1) {
      selectionTemp.push(value);
      selectionIndex.push(selectionT);
    } else {
      selectionTemp.splice(ind, 1);
      selectionIndex.splice(ind, 1);
    }

    setSelection([...selectionTemp]);
  };

  const callAnalyticsOnUpdate = () => {
    const selectedCategories = selection.map((i) => i.label);
    Analytics.track('Career Path Update', {
      'Updated Question':
        'What categories are you looking to address in your entrepreneurial journey?',
      'Updated Answer': selectedCategories,
    });
    Analytics.people.set({
      Categories: selectedCategories,
    });
  };

  const handleUpdate = () => {
    if (selection.length > 1) {
      setCareerPaths({
        ...careerPaths,
        interest: { ...interest, answer: [...selection], answerIndex: [...selectionIndex] },
      });
      callAnalyticsOnUpdate();
      onClose();
    }
  };
  return (
    <div className="ml-8">
      <label className="text-black mb-8 block px-32 font-medium">
        What categories are you looking to address in your entrepreneurial journey?
      </label>
      <label className="mb-32 block px-32 text-sm">Select atleast two categories</label>
      <div className="flex flex-wrap ml-24">
        {interest
          ? interest?.options?.map((option, index) => (
              <TileButtonTwo
                key={`${option.value}-${index}`}
                selected={selection?.find?.((item) => item.value === option.value)}
                onClick={handleMultiselectDropdown.bind(this, option)}
                className="mr-24 mb-24 w-284"
              >
                {option.label}
              </TileButtonTwo>
            ))
          : null}
      </div>
      <div className="flex justify-end border-t ">
        <Button
          status="secondary"
          className="mr-10 mt-8 min-w-107 justify-center"
          onClick={onClose}
        >
          Back
        </Button>
        <Button
          size="lg"
          className="justify-center mt-10"
          disabled={selection.length > 1 ? false : true}
          onClick={handleUpdate}
        >
          Update
        </Button>
      </div>
    </div>
  );
};
